<script setup lang="ts">
import { useAuthService } from '~/composables/useAuthService'
import { useAuthModal } from '~/composables/useAuthModal'

const { initAuth } = useAuthService()
const { isUnauthorizedModalOpen, closeUnauthorizedModal } = useAuthModal()

// Restore session on app mount (client-side)
onMounted(() => {
    initAuth() 
})

const handleUnauthorizedClose = () => {
    closeUnauthorizedModal()
    const router = useRouter()
    router.push('/auth/login')
}
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <ui-error-modal 
      :is-open="isUnauthorizedModalOpen"
      title="Session clôturée"
      message="Votre session a été clôturée."
      @close="handleUnauthorizedClose"
    />
  </div>
</template>
